import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { CheckboxList } from "@platform/design-system";

import { buildToggleCoverageHiddenDiff } from "../grid/buildPatchDiff";

import type { CustomToolPanelProps } from "ag-grid-react";
import type { FinancialsGridContext } from "../grid/types";

export const CoveragesPanel = ({
  api,
}: CustomToolPanelProps): React.JSX.Element => {
  const [, rerender] = useState(0);

  useEffect(() => {
    const handler = (): void => rerender((n) => n + 1);
    api.addEventListener("modelUpdated", handler);

    return () => api.removeEventListener("modelUpdated", handler);
  }, [api]);

  const context = api.getGridOption("context") as FinancialsGridContext;
  const { payload, queueChange } = context;

  const coverageItems = [...payload.coverages]
    .sort((a, b) => a.order - b.order)
    .map((coverage) => ({
      id: coverage.id,
      label: coverage.name,
      checked: !coverage.hidden,
    }));

  const handleToggleCoverage = (coverageId: string): void => {
    const coverage = payload.coverages.find((c) => c.id === coverageId);
    if (!coverage) return;
    queueChange(
      buildToggleCoverageHiddenDiff(
        coverageId,
        coverage.hidden,
        payload.coverages,
      ),
    );
  };

  return (
    <Box
      data-testid="coverages-panel"
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <Box sx={{ flex: 1, overflowY: "auto" }}>
        <CheckboxList items={coverageItems} onToggle={handleToggleCoverage} />
      </Box>
    </Box>
  );
};
